import { JumboTitleBlock, JumboTitleRecord } from '@/components/blocks/Shared/JumboTitleBlock'
import { MediaAndTextBlock, MediaAndTextRecord } from '@/components/blocks/ModularLandingPage/MediaAndTextBlock'
import {
  FullWidthMediaAssetBlock,
  FullWidthMediaAssetRecord,
} from '@/components/blocks/ModularLandingPage/FullWidthMediaAssetBlock'
import { FullWidthTextBlock, FullWidthTextRecord } from '@/components/blocks/ModularLandingPage/FullWidthTextBlock'
import { LinkCollectionBlock, LinkCollectionRecord } from '@/components/blocks/ModularLandingPage/LinkCollectionBlock'
import { CardsBlock, CardsSectionRecord } from '@/components/blocks/Shared/CardsBlock'
import { AppDownloadBlock, AppDownloadSectionRecord } from '@/components/blocks/Shared/AppDownloadBlock'
import { VideoFullWidthBlock, VideoFullWidthRecord } from '@/components/blocks/Shared/VideoFullWidthBlock'
import { InfoSurfaceBlock } from '@/components/blocks/Shared/InfoSurfaceBlock'
import { SpacerBlock } from '@/components/blocks/DesignSystem/Spacer'

type ModularLandingPageContentBlocks =
  | JumboTitleRecord
  | MediaAndTextRecord
  | FullWidthMediaAssetRecord
  | FullWidthTextRecord
  | LinkCollectionRecord
  | CardsSectionRecord
  | AppDownloadSectionRecord
  | VideoFullWidthRecord

const renderBlock = (record, index) => {
  const key = `${record.id}-${index}}`
  switch (record.__typename) {
    case 'JumboTitleRecord':
      return <JumboTitleBlock key={key} record={record} />
    case 'MediaAndTextRecord':
      return <MediaAndTextBlock key={key} record={record} />
    case 'FullWidthMediaAssetRecord':
      return <FullWidthMediaAssetBlock key={key} record={record} />
    case 'FullWidthTextRecord':
      return <FullWidthTextBlock key={key} record={record} />
    case 'LinkCollectionRecord':
      return <LinkCollectionBlock key={key} record={record} />
    case 'CardsSectionRecord':
      return <CardsBlock key={key} record={record} />
    case 'AppDownloadSectionRecord':
      return <AppDownloadBlock key={key} record={record} />
    case 'VideoFullWidthRecord':
      return <VideoFullWidthBlock key={key} record={record} />
    case 'InfoSurfaceRecord':
      return <InfoSurfaceBlock key={key} record={record} />
    case 'SpacerRecord':
      return <SpacerBlock key={key} record={record} />
  }
}

type ModularLandingPageContentProps = {
  content: ModularLandingPageContentBlocks[]
}

export const ModularLandingPageContent = ({ content }: ModularLandingPageContentProps) => {
  return <>{(content ?? []).map((record, index) => renderBlock(record, index))}</>
}
